import collectorInformationSlice from './collectorInformationSlice'

export {
  addCollector,
  selectCollectors
} from './collectorInformationSlice'

export default collectorInformationSlice
